import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'sq',
    fullName: 'Albanian',
    nativeName: 'Shqip',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Diçka e mahnitshme po vjen",
    landing_subtitle: "ArgVoid është një studio e zhvillimit të aplikacioneve dhe lojërave. Qëndroni të sintonizuar, gjëra të reja do të vijnë së shpejti!",
    select_language: "Zgjidhni gjuhën",
    search_placeholder: "Kërko gjuhët...",
    terms_title: "Kushtet e Shërbimit",
    policy_title: "Politika e privatësisë",
    cookies_title: "Politika e kukive",
    terms_content: `
        <strong>1. Pranimi i kushteve</strong><br>
        Duke hyrë në ArgVoid, këto Kushte të Shërbimit pranohen. Nëse këto kushte nuk bien dakord, shërbimi nuk duhet të përdoret.<br><br>

        <strong>2. Përdorimi i platformës</strong><br>
        ArgVoid dhe aplikacionet e tij ofrohen "siç është" për qëllime informative dhe krijuese. Shërbimi duhet të përdoret vetëm për qëllime të ligjshme.<br><br>

        <strong>3. Sjellje e ndaluar</strong><br>
        Ndalohet rreptësisht shfrytëzimi i dobësive të sajtit, dërgimi i mesazheve të bezdisshme ose përpjekja për akses të paautorizuar në infrastrukturë.<br><br>

        <strong>4. Mohim </strong><br>
        Platforma dhe shërbimet mund të modifikohen në çdo kohë pa paralajmërim. Asnjë garanci nuk jepet në lidhje me kohën e funksionimit ose disponueshmërinë e shërbimit.
    `,
    policy_content: `
        <strong>1. Mbledhja e informacionit</strong><br>
        Platforma nuk kërkon vërtetimin e përdoruesit ose krijimin e llogarisë në këtë moment. Asnjë informacion personal identifikues (si emrat ose adresat e emailit) nuk mblidhet në mënyrë aktive nga vizitorët.<br><br>

        <strong>2. Përdorimi i të dhënave</strong><br>
        Analiza bazë, e anonimizuar mund të mblidhet për të kuptuar trafikun e sajtit dhe për të përmirësuar aplikacionet. Këto të dhëna nuk janë të lidhura me identitetet individuale të përdoruesve.<br><br>

        <strong>3. Shërbimet e palëve të treta</strong><br>
        Ofruesit e palëve të treta mund të përdoren për shërbimet e pritjes dhe analitikës. Praktikat e privatësisë së këtyre ofruesve përkatës rregullojnë të dhënat anonime të përpunuara në infrastrukturën e tyre.<br><br>

        <strong>4. Siguria e të dhënave</strong><br>
        Janë zbatuar masa të arsyeshme sigurie për të mbrojtur platformën. Megjithatë, asnjë metodë transmetimi përmes internetit nuk është plotësisht e sigurt.<br><br>
    `,
    cookies_content: `
        <strong>1. Çfarë janë cookies dhe hapësira ruajtëse lokale?</strong><br>
        Cookies dhe ruajtja lokale e shfletuesit janë skedarë të vegjël të dhënash të ruajtura në pajisje për të mbajtur mend preferencat e konfigurimit përgjatë vizitave.<br><br>

        <strong>2. Qëllimi i përdorimit</strong><br>
        Shfletuesi LocalStorage përdoret rreptësisht për të ruajtur cilësimet e konfigurimit, të tilla si:<br>
        - Preferencat gjuhësore<br>
        - Konfigurimi i ndërfaqes së përdoruesit (p.sh., cilësimet e paraqitjes ose temës) <br>
        - Cache e përkohshme e aplikacionit<br><br>

        <strong>3. Nuk ka gjurmim</strong><br>
        Cookies dhe ruajtja lokale nuk përdoren për qëllime reklamimi ose gjurmimi nga palët e treta. Të gjitha të dhënat e ruajtura janë rreptësisht për funksionalitetin bazë të platformës.<br><br>

        <strong>4. Kontrolli</strong><br>
        Të dhënat e shfletuesit mund të pastrohen në çdo kohë përmes cilësimeve të shfletuesit, të cilat do të rivendosin çdo konfigurim lokal.
    `,
    cookie_consent_text: "Ne përdorim cookie bazë për të siguruar funksionimin e saktë të faqes së internetit, si mbajtja e sesionit tuaj aktiv, ruajtja e preferencës suaj të gjuhës dhe konfigurime të tjera të personalizuara.",
    read_policy: "Lexoni Politikën e Cookie",
    support_title: "Kontaktoni mbështetjen",
    support_subject_label: "Subjekti",
    support_message_label: "Mesazh",
    support_submit_button: "Dërgo Mesazh",
    support_hint: "Shënim: Kjo do të hapë aplikacionin tuaj të paracaktuar të emailit për të dërguar mesazhin.",
    support_success_msg: "Po hap aplikacionin tuaj të emailit...",
    support_error_msg: "Dërgimi i mesazhit dështoi. Ju lutemi provoni përsëri më vonë.",
    explorer_title: "Eksplorues",
    history_title: "Historia",
    animation_title: "Animacion",
    config_title: "Konfigurimi",
    tool_mouse: "Zgjidh (Ctrl+M)",
    tool_brush: "Furça (Ctrl+B)",
    tool_brush_mode: "Ndrysho modalitetin (e ngurtë/e pastër)",
    tool_eraser: "Gomë (Ctrl+E)",
    tool_brush_size: "Rregulloni madhësinë e furçës",
    tool_bucket: "Plotësoni (Ctrl+F)",
    tool_eyedropper: "Pika për sy",
    tool_grid: "Rrjeti (Ctrl+Shift+B)",
    tool_rotate: "Rrotulloje (Ctrl+Shift+R)",
    tool_flip_h: "Kthejeni H (Ctrl+Shift+H)",
    tool_flip_v: "Ktheje V (Ctrl+Shift+V)",
    tool_transpose: "Transpozoni (Ctrl+Shift+T)",
    label_width: "Gjerësia",
    label_height: "Lartësia",
    label_frames: "Numri i Kornizave",
    label_animation: "Stili i animacionit",
    label_background_color: "Ngjyra e sfondit",
    label_interval: "Intervali",
    tool_anim_config: "Konfigurimi i animacionit",
    label_new_width: "Gjerësia e re",
    label_new_height: "Lartësia e re",
    label_apply: "Aplikoni",
    label_colors: "Ngjyrat",
    label_size: "Madhësia",
    label_tolerance: "Toleranca",
    val_horizontal: "Horizontale",
    val_vertical: "Vertikale",
    val_sequence: "Sekuenca",
    val_bounce: "Kërcej",
    val_random: "E rastësishme",
    val_solid: "Të ngurta",
    val_clear: "E qartë",
    action_add_sheet: "Fletë e re",
    action_import: "Importi",
    action_export: "Eksporto",
    action_sort_projects: "Rendit",
    sort_date_old: "I pari më i vjetër",
    sort_date_new: "Më të rejat e para",
    sort_name_az: "Emri (A-Z)",
    sort_name_za: "Emri (Z-A)",
    action_new_sprite: "Sprite e re",
    action_new_project: "Projekt i ri",
    modal_save_all_title: "Ruaj të gjitha ndryshimet",
    modal_save_all_desc: "Zgjidhni asetet për të kursyer:",
    modal_save_selected: "Ruaj të zgjedhurin",
    action_saved: "U ruajt",
    modal_create_sprite_title: "Krijo Sprite të Re",
    modal_create_project_title: "Krijo projekt të ri",
    modal_add_sheet_title: "Shto fletë të re",
    modal_rename_sheet_title: "Riemërto fletën",
    modal_rename_sprite_title: "Riemërto Sprite",
    modal_delete_sprite_title: "Fshi Sprite",
    modal_delete_project_title: "Fshi projektin",
    modal_delete_sheet_title: "Fshi Fletën",
    placeholder_sprite_name: "Emri",
    placeholder_project_name: "Emri",
    placeholder_sheet_name: "Emri",
    placeholder_new_name: "Emri i ri",
    action_create: "Krijo",
    action_add: "Shtoni",
    action_rename: "Riemërto",
    action_duplicate: "Dublikatë",
    action_delete: "Fshije",
    action_cancel: "Anulo",
    confirm_delete_sprite: "Je i sigurt që dëshiron ta fshish këtë sprite?",
    confirm_delete_project: "Jeni i sigurt që dëshironi ta fshini këtë projekt? Të gjitha spritet do të hiqen.",
    confirm_delete_sheet: "Je i sigurt që dëshiron ta fshish këtë fletë?",
    err_select_sprite: "Së pari, zgjidhni një sprite.",
    err_select_project: "Ju lutemi zgjidhni fillimisht një projekt.",
    err_name_empty: "Emri nuk mund të jetë bosh.",
    err_sprite_exists: "Një sprite me atë emër ekziston tashmë.",
    err_project_exists: "Një projekt me atë emër ekziston tashmë.",
    err_no_content: "Nuk ka përmbajtje për të ruajtur.",
    err_no_changes: "Nuk ka ndryshime për të ruajtur.",
    err_delete_last_sheet: "Fleta e fundit nuk mund të fshihet.",
    err_extract_frames: "Nuk mund të nxirret asnjë kornizë.",
    err_indexeddb: "Ruajtja në nivel lokal dështoi. Shfletuesi juaj mund të mos mbështesë IndexedDB.",
    msg_upload_success: "Ngarkimi u krye me sukses: {0}",
    msg_upload_failed: "Ngarkimi dështoi: {0}",
    msg_save_success: "Ruajtja me sukses.",
    msg_saving: "Po ruan...",
    msg_multi_save_result: "{0} aktive të ruajtura. {1} dështime.",
    menu_title: "Menyja",
    menu_save: "Ruaj",
    menu_save_all: "Ruaj të gjitha",
    menu_support: "Kontaktoni mbështetjen",
    label_local_storage: "Magazinimi lokal",
    label_sign_in: "Hyni",
    modal_export_title: "Eksporto Sprite",
    label_filename: "Emri i skedarit",
    label_format: "Formati",
    action_export_confirm: "Eksporto",
};

export default translations;
